import { Howl } from 'howler'
import axios from 'axios'

export default {
  install: function install (Vue) {
    // Event-bus 相当于简单的store
    const bus = new Vue({
      data () {
        return {
          musicOn: true,
          musicLoaded: false,
          audios: {}, // 音频缓冲
          playedMusic: [],
          lastSceneMusic: '',
          audioList: {
            bg: 'http://cdn.shikehuyu.com/yfjs/audios/bg.mp3',
            s1: 'http://cdn.shikehuyu.com/yfjs/audios/s1.mp3',
            bell: 'http://cdn.shikehuyu.com/yfjs/audios/bell.mp3',
            s2: 'http://cdn.shikehuyu.com/yfjs/audios/s2.mp3',
            children: 'http://cdn.shikehuyu.com/yfjs/audios/children.mp3',
            s3: 'http://cdn.shikehuyu.com/yfjs/audios/s3.mp3',
            walk: 'http://cdn.shikehuyu.com/yfjs/audios/walk.mp3',
            s4: 'http://cdn.shikehuyu.com/yfjs/audios/s4.mp3',
            crowd: 'http://cdn.shikehuyu.com/yfjs/audios/crowd.mp3',
            s5: 'http://cdn.shikehuyu.com/yfjs/audios/s5.mp3',
            money: 'http://cdn.shikehuyu.com/yfjs/audios/money.mp3',
            s6: 'http://cdn.shikehuyu.com/yfjs/audios/s6.mp3',
            meeting: 'http://cdn.shikehuyu.com/yfjs/audios/meeting.mp3',
            shake: 'http://cdn.shikehuyu.com/yfjs/audios/shake.mp3',
            wechat: 'http://cdn.shikehuyu.com/yfjs/audios/wechat.mp3',
            message1: 'http://cdn.shikehuyu.com/yfjs/audios/message.mp3',
            message2: 'http://cdn.shikehuyu.com/yfjs/audios/message.mp3',
            message3: 'http://cdn.shikehuyu.com/yfjs/audios/message.mp3',
            s8: 'http://cdn.shikehuyu.com/yfjs/audios/s8.mp3'
          }
        }
      },

      methods: {
        getWxConfig () {
          return axios({
            url: 'http://wx.shikehuyu.com/jssdk',
            params: {
              url: location.href.split('#')[0]
            }
          }).then((response) => {
            const result = response.data
            if (result.code === 0) {
              return result.package
            }
            return null
          })
        },
        configWx (packageData) {
          if (packageData) {
            window.wx.config({
              debug: false,
              appId: packageData.appId, // 必填，公众号的唯一标识
              timestamp: packageData.timestamp, // 必填，生成签名的时间戳
              nonceStr: packageData.nonceStr, // 必填，生成签名的随机串
              signature: packageData.signature, // 必填，签名
              jsApiList: [
                'onMenuShareTimeline', 'onMenuShareAppMessage'
              ] // 必填，需要使用的JS接口列表
            })
            window.wx.ready(() => {
              window.wx.onMenuShareTimeline({
                title: '“爸妈，等我放假就陪你们......”', // 分享标题
                link: `${location.href.split('?')[0]}?tmp=${Date.now()}`,
                imgUrl: 'http://cdn.shikehuyu.com/yfjs/public/share-new.jpg' // 分享图标
              })
              window.wx.onMenuShareAppMessage({
                title: '“爸妈，等我放假就陪你们......”', // 分享标题
                desc: '人在路上，让爱先回家', // 分享描述
                link: `${location.href.split('?')[0]}?tmp=${Date.now()}`,
                imgUrl: 'http://cdn.shikehuyu.com/yfjs/public/share-new.jpg' // 分享图标
              })
            })
          }
        },
        // 音乐开关
        toggleMusic () {
          this.musicOn = !this.musicOn
          if (this.musicOn) {
            this.musicFadeIn('bg')
          } else {
            this.musicFadeOut('bg')
          }
        },
        // 加载音乐
        loadMusic () {
          if (!this.musicLoaded) {
            this.musicLoaded = true
            Object.keys(this.audioList).forEach((name) => {
              this.audios[name] = new Howl({
                src: this.audioList[name],
                loop: name === 'bg',
                volume: name === 'bg' ? 0.8 : 1
              })
            })
          }
        },
        // 播放音乐
        playMusic (name) {
          if (name in this.audios && this.musicOn) {
            if (name === 'bg' || this.playedMusic.indexOf(name) === -1) {
              if (name.match(/^s\d+$/)) { // 旁白
                if (this.lastSceneMusic) this.audios[this.lastSceneMusic].stop()
                this.lastSceneMusic = name
              }
              this.audios[name].play()
              if (name !== 'bg') this.playedMusic.push(name)
            }
          }
        },
        // 循环音乐
        loopMusic (name) {
          if (name in this.audios) {
            this.audios[name].loop(true)
          }
        },
        // 音乐淡入
        musicFadeIn (name, from = 0, to = 1, duration = 1000) {
          if (name in this.audios) {
            this.audios[name].fade(from, to, duration)
          }
        },
        // 音乐淡出
        musicFadeOut (name, from = 1, to = 0, duration = 1000) {
          if (name in this.audios) {
            this.audios[name].fade(from, to, duration)
          }
        }
      }
    })
    bus.getWxConfig().then(bus.configWx)
    /* eslint no-param-reassign: ["error", { "props": false }] */
    Vue.prototype.$bus = bus
  }
}



// WEBPACK FOOTER //
// ./src/plugin/bus.js